<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((f) => f.isCheckedToDelete)"
						@confirm="deleteModels"
						@cancel="toggleExclusionAlert"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.espe_cd_codigo }} - {{ $t('name') }} :
								{{ item.espe_ds_nome }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						style="border-radius: 5px !important; min-width: 65px"
						@click="downloadCSVEspecie()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; gap: 0.5rem; flex-direction: column">
					<InputText
						v-model="model.espe_ds_nome"
						:label="$t('scientificName') + '*'"
					/>
					<!-- <Accordion :label="$t('optionalFields')" :hints="[$t('description')]"> -->
					<InputText
						v-model="model.espe_ds_descricao"
						:label="$t('description')"
					/>
					<!-- </Accordion> -->
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../../components/Pagination/Pagination'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createEspecie,
	deleteEspecieByIdList,
	getAllEspecies,
	updateEspecie,
} from '../../../../services/requests/EspecieRequests'

import validarEspecie from '../../../../validations/EspecieValidation'
import { exportarCsv } from '../../../../utils/csvHellpers'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		// Accordion,
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		// DownloadButton,
		ExclusionAlert,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			headersSelecionados: ['espe_cd_codigo', 'espe_ds_nome', 'espe_ds_descricao'],
			showExclusionAlert: false,
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				espe_cd_codigo: '',
				espe_ds_descricao: '',
				espe_ds_nome: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'ES',
				subtitleCardPropertie: 'espe_ds_nome',
				titleCardPropertie: 'espe_cd_codigo',
			},
			tableHeaders: [
				{ key: 'espe_cd_codigo', value: this.$t('code'), isActive: true },
				{
					key: 'espe_ds_nome',
					value: this.$t('scientificName'),
					isActive: true,
				},
				{
					key: 'espe_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
			],
		}
	},
	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.espe_ds_nome
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['espe_cd_codigo']
		getAllEspecies().then((response) => {
			const { result } = response.data
			result.forEach((f) => (f.isCheckedToDelete = false))
			this.modelList = result
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createEspecieToPost() {
			return {
				id: uuidv4(),
				espe_ds_descricao: this.model.espe_ds_descricao,
				espe_ds_nome: this.model.espe_ds_nome.trim(),
			}
		},

		downloadCSVEspecie() {
			let cabecalhoDoCsvEspecie = ['Código', 'Nome Científico', 'Descrição ']
			const items = this.modelList

			const linhas = items.map((item) => [
				item.espe_cd_codigo,
				item.espe_ds_nome,
				item.espe_ds_descricao,
			])

			exportarCsv('export_especie', cabecalhoDoCsvEspecie, linhas)
		},

		/**
		 * Cria novo Especie no banco de dados
		 */
		create() {
			const especie = this.createEspecieToPost()
			const { isValid } = validarEspecie(especie, this.modelList)

			if (isValid) {
				createEspecie(especie).then((response) => {
					const { result: especie, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						especie.isCheckedToDelete = false
						this.modelList.unshift(especie)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			} else {
				this.disableSaveButton = false
				this.mutationShowMessage({
					messageTitle: 'Erro',
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Atualiza especie no banco de dados
		 */
		update() {
			updateEspecie(this.model).then((response) => {
				const { result: model, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					model.isCheckedToDelete = false

					const indexModel = this.modelList.map((m) => m.id).indexOf(this.model.id)
					this.$set(this.modelList, indexModel, model)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (emailUsuario === email) {
				const existeRegistroComDependencia = this.modelList.filter(
					(especie) =>
						this.modelsIdWithCheckedToDelete.includes(especie.id) &&
						especie.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteEspecieByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var especiesOrganizadas = existeRegistroComDependencia
						.map(
							(especie) =>
								`• Especie: ${especie.espe_cd_codigo} / Plantio: ${especie.espe_ds_nome}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('materialGeneticoAtrelado')}:</b> <br/><br/> ${especiesOrganizadas}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			this.titleForm = `${this.$t('edit')} ${this.$t('species')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('species')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
